export default __webpack_public_path__ + "static/media/nonactive.1a8ca381.svg";